import axios from "axios";

const { REACT_APP_AUTH_API } = process.env;

const { CancelToken } = axios;
const source = CancelToken.source();

export const getUsers: any = (companyId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_AUTH_API}/${companyId}/users?results_per_page=200`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};

// new user endpoints
export const getUsersNew: any = (
  company,
  page,
  query,
  pageSize = 30,
  orderBy = "first_name",
  order = "asc",
  cancelToken = source.token,
  filterBy = "",
) => {
  const url = `q=${query}&results_per_page=${pageSize}&page=${page}&order_by=${orderBy}&order=${order}`;
  const params = new URLSearchParams(url);
  if (filterBy) {
    params.set("filters", filterBy);
  }
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_AUTH_API}/${company}/users?${params.toString()}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    cancelToken,
  })
    .then((response) => {
      return { data: response.data };
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};

export const getUser: any = (company, userID) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_AUTH_API}/${company}/users/${userID}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return { data: response.data.data };
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};

export const updateUser: any = (company, userID, body) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "put",
    url: `${REACT_APP_AUTH_API}/${company}/users/${userID}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: body,
  })
    .then((response) => {
      return { data: response.data.data };
    })
    .catch((e) => {
      return { detail: e.response.data };
    });
};

export const createUser: any = (company, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "post",
    url: `${REACT_APP_AUTH_API}/${company}/users`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return { data: response.data };
    })
    .catch((e) => {
      return { detail: e.response.data };
    });
};

export const resendInvite: any = (companyID, userID) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_AUTH_API}/${companyID}/users/${userID}/send_invitation_email`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return { data: response.data.data };
    })
    .catch((error) => {
      return { detail: error.response.data };
    });
};

export const deleteUser = (companyID, userID) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "delete",
    url: `${REACT_APP_AUTH_API}/${companyID}/users/${userID}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return { data: response?.data };
    })
    .catch((error) => {
      console.error("axios error", error);
      return {
        data: { detail: "you are not allowed to delete an admin" },
      };
    });
};

export const deleteUsers = async (
  customerId: string,
  userIds: string,
  query: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const params = new URLSearchParams();
  if (userIds && userIds !== "all") {
    params.set("user_ids_in", userIds);
  } else if (query && userIds && userIds === "all") {
    params.set("q", query);
  }
  const response = await axios({
    method: "delete",
    url: `${REACT_APP_AUTH_API}/${customerId}/users?${params.toString()}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response?.data;
};

export const downloadUsers = async (
  customerId: string,
  userIds: string,
  query,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  const response = await axios({
    method: "get",
    url: `${REACT_APP_AUTH_API}/${customerId}/users/download?users_ids_in=${userIds}&q=${query}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response?.data?.data;
};

export const importUsers = async (customerId: string, users: any) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_AUTH_API}/${customerId}/users/import`,
      headers: { Authorization: `Bearer ${token}` },
      data: users,
    });
    return response;
  } catch (e) {
    return { e };
  }
};
